// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconChevronUp = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M53.2918 35.7389C52.3662 34.8764 34.2214 17.9723 33.3634 17.1728C32.5052 16.3734 31.4947 16.3734 30.6366 17.1728C29.7785 17.9723 11.6337 34.8764 10.7082 35.7389C9.78267 36.6012 9.76283 37.7218 10.6574 38.6163C11.5518 39.5108 12.4895 40.4485 13.384 41.3429C14.2785 42.2374 15.3992 42.2176 16.2615 41.2921C16.9339 40.5704 27.4149 29.3204 32 24.3987C36.5852 29.3204 47.0661 40.5704 47.7385 41.2921C48.6008 42.2176 49.7214 42.2374 50.616 41.343C51.5104 40.4485 52.4481 39.5108 53.3426 38.6163C54.2371 37.7218 54.2173 36.6012 53.2918 35.7389Z" />
    </svg>
  );
};
